import { AuthCredentialsSection } from '../components/AuthCredentialsSection';
import { AuthContactPrompt } from '../components/AuthContactSupport';
import { PageChrome } from '../components/PageChrome';
import { OTHER_SIGN_IN_LOGIN_OPTIONS, type LoginOption } from '../login/loginConstants';
import { useI18n } from '../i18n';
import styles from './AuthRoleLoginPage.module.css';

export type AuthOtherSignInPageProps = {
  onBack: () => void;
  onContact: () => void;
  onForgotPassword: (loginType: LoginOption) => void;
};

/** Password sign-in — business clients, workers, asset owners, etc. */
export function AuthOtherSignInPage({ onBack, onContact, onForgotPassword }: AuthOtherSignInPageProps) {
  const { t } = useI18n();

  return (
    <PageChrome title={t('auth.portal.otherSignInTitle')} onBack={onBack}>
      <div className={styles.page}>
        <AuthCredentialsSection
          allowedLoginOptions={OTHER_SIGN_IN_LOGIN_OPTIONS}
          onForgotPassword={onForgotPassword}
        />
        <footer className={styles.footer}>
          <AuthContactPrompt onContact={onContact} />
        </footer>
      </div>
    </PageChrome>
  );
}

/** @deprecated Use AuthOtherSignInPage */
export const AuthBusinessOrOwnerLogin = AuthOtherSignInPage;
